import { SpinResponse } from '@cgs/data-access';
import { MachineStateDto } from '../../models';
import { bonusInfoMapper } from './bonus-info.mapper';
import { freeSpinsInfoMapper } from './free-spins-info.mapper';
import { collapseInfoMapper } from './collapse-info.mapper';
import { winLineMapper } from './win-line.mapper';
import { winPositionMapper } from './win-position.mapper';
import { defaultSpecGroupMapper } from './default-spec-group.mapper';
import { gambleInfoMapper } from './gamble-info.mapper';

export function machineStateMapper(state: MachineStateDto): SpinResponse {
  const result: SpinResponse = new SpinResponse();

  result.aboveReels = state.aboveReels || [];
  result.belowReels = state.belowReels || [];
  result.viewReels = state.viewReels || [];
  result.bonusInfo = state.bonusInfo ? bonusInfoMapper(state.bonusInfo) : null;
  result.totalWin = state.totalWin || 0;
  result.totalLost = state.totalLost || 0;
  result.bigWinName = state.winningName ?? '';
  result.freeSpinsInfo = state.freeSpinsInfo ? freeSpinsInfoMapper(state.freeSpinsInfo) : null;
  result.reSpinsInfo = state.reSpinsInfo ? freeSpinsInfoMapper(state.reSpinsInfo) : null;
  result.collapseInfo = state.collapseInfo ? collapseInfoMapper(state.collapseInfo) : null;
  result.gambleInfo = state.gambleInfo ? gambleInfoMapper(state.gambleInfo) : null;
  result.winLines = winLineMapper(state.winLines || []);
  result.winPositions = winPositionMapper(state.winPositions || []);
  result.specialSymbolGroups = defaultSpecGroupMapper(state.defaultSpecGroups || []);
  result.additionalData = null;
  return result;
}
